// GENERATED by packages/i18n/scripts/gen-en-roles.mjs from handover/role-reference.json — do not edit.
export const enRoles = {
  "role.org-admin.title": "Organisation administrator",
  "role.org-admin.heading": "A consistent foundation for every site.",
  "role.org-admin.intro": "Manage people, policy and the shared operating framework. Operational and privacy powers are separate grants.",
  "role.org-admin.boundary": "No visitor admission, access provisioning, privacy deletion or incident command.",
  "role.org-admin.primary": "Review users",
  "role.org-admin.task1.title": "User access",
  "role.org-admin.task1.body": "Review active accounts and protect the last administrator.",
  "role.org-admin.task2.title": "Policy versions",
  "role.org-admin.task2.body": "Draft the approval pattern; this does not enforce a live policy.",
  "role.org-admin.task3.title": "Site framework",
  "role.org-admin.task3.body": "Review locations and room capacity.",
  "role.site-admin.title": "Site administrator",
  "role.site-admin.heading": "Keep your site ready to welcome.",
  "role.site-admin.intro": "Maintain local spaces and operating instructions without inheriting organisation-wide security powers.",
  "role.site-admin.boundary": "No global users, approval decisions, access commands or privacy cases.",
  "role.site-admin.primary": "Manage spaces",
  "role.site-admin.task1.title": "Rooms & spaces",
  "role.site-admin.task1.body": "Review capacity and add a local meeting space.",
  "role.site-admin.task2.title": "Local communication",
  "role.site-admin.task2.body": "Review templates and routing drafts; no messages are sent.",
  "role.host.title": "Host / employee",
  "role.host.heading": "Your guests. One clear plan.",
  "role.host.intro": "Invite visitors, keep plans current and follow the arrival journey. Your view includes only visits hosted by Omar.",
  "role.host.boundary": "Cannot approve your own requests, verify identity, admit visitors or view another host’s records.",
  "role.host.primary": "Invite a visitor",
  "role.host.task1.title": "Your invitations",
  "role.host.task1.body": "Create, amend or cancel a visit and track its independent states.",
  "role.reception.title": "Reception",
  "role.reception.heading": "Make every arrival feel effortless.",
  "role.reception.intro": "See who is expected, resolve missing prerequisites and record actual arrivals and departures.",
  "role.reception.boundary": "Cannot approve visits or confirm a logical access outcome. Credential exceptions go to the platform operator.",
  "role.reception.primary": "Open arrival desk",
  "role.reception.task1.title": "Arrival desk",
  "role.reception.task1.body": "Verify evidence and record observed presence.",
  "role.reception.task2.title": "Physical custody",
  "role.reception.task2.body": "Assign or recover a card without implying logical access.",
  "role.reception.task3.title": "Package handover",
  "role.reception.task3.body": "Track the package separately from the courier.",
  "role.approver.title": "Approver",
  "role.approver.heading": "Clear decisions. Traceable reasons.",
  "role.approver.intro": "Review pending requests, record a decision and keep approval distinct from identity and admission.",
  "role.approver.boundary": "Review identity is Sara Al Noor for the own-host check. Sara’s own requests cannot be approved here; reassignment is specified, not simulated.",
  "role.approver.primary": "Review requests",
  "role.approver.task1.title": "Approval inbox",
  "role.approver.task1.body": "Make a reasoned decision on a request owned by another host.",
  "role.guard.title": "Guard / gate operator",
  "role.guard.heading": "Know the blocker before the barrier.",
  "role.guard.intro": "Check a linked visit and record a gate observation. A recognised vehicle never means permission to enter.",
  "role.guard.boundary": "No visitor directory, identity evidence, policy changes or remote barrier actuation.",
  "role.guard.primary": "Review gate queue",
  "role.guard.task1.title": "Gate checks",
  "role.guard.task1.body": "Plate, visit eligibility and observed movement stay separate.",
  "role.permit.title": "Contractor / permit reviewer",
  "role.permit.heading": "The right evidence before work begins.",
  "role.permit.intro": "Review contractor evidence and bounded work authorisation. A permit does not replace individual visitor checks.",
  "role.permit.boundary": "Cannot grant logical access or mark people as departed. Suspension creates unresolved access work where necessary.",
  "role.permit.primary": "Review work permits",
  "role.permit.task1.title": "Work packages",
  "role.permit.task1.body": "Accept evidence before approving the permit; inspect suspension impact.",
  "role.emergency.title": "Emergency coordinator",
  "role.emergency.heading": "Account for people. Expose uncertainty.",
  "role.emergency.intro": "Start a training muster, review the captured roster and record individual observations. This is not an emergency service.",
  "role.emergency.boundary": "Does not trigger alarms, guarantee physical location or rewrite visitor presence from a roll-call observation.",
  "role.emergency.primary": "Open training muster",
  "role.emergency.task1.title": "Muster coordination",
  "role.emergency.task1.body": "Capture a roster, account for each person and close with a reason.",
  "role.analyst.title": "Analyst / report-only",
  "role.analyst.heading": "Understand the operation, not the identity.",
  "role.analyst.intro": "Review scoped totals and independent state counts. This proposed reporting profile has no person-level export grant.",
  "role.analyst.boundary": "No visitor names, raw event log, scheduled exports or operational changes. AI remains an optional Enterprise+ add-on.",
  "role.analyst.primary": "View aggregate report",
  "role.analyst.task1.title": "Daily operating picture",
  "role.analyst.task1.body": "Compare observed presence, pending approvals and unknown access outcomes.",
  "role.auditor.title": "Auditor",
  "role.auditor.heading": "Follow the evidence, without changing it.",
  "role.auditor.intro": "Review who did what and where uncertainty remains. Demo history is editable local data, not a tamper-resistant audit service.",
  "role.auditor.boundary": "No operational decisions, user administration, privacy case editing or record mutation.",
  "role.auditor.primary": "Inspect audit trail",
  "role.auditor.task1.title": "Event review",
  "role.auditor.task1.body": "Inspect actor, action, scope and record reference.",
  "role.privacy.title": "Privacy reviewer",
  "role.privacy.heading": "Respect the request. Prove the outcome.",
  "role.privacy.intro": "Verify the requester, review the hold and track each simulated storage outcome before closing a case.",
  "role.privacy.boundary": "No blanket record deletion, user administration or assumed downstream completion. Retention periods remain unresolved.",
  "role.privacy.primary": "Open subject requests",
  "role.privacy.task1.title": "Subject requests",
  "role.privacy.task1.body": "Identity, scope, hold and store results are separate review steps.",
  "role.operator.title": "Integration / platform operator",
  "role.operator.heading": "Recover the outcome, not just the connection.",
  "role.operator.intro": "Inspect dependency health and reconcile uncertain credentials using simulated read-back outcomes.",
  "role.operator.boundary": "No routine visitor admission, approval, privacy deletion or user-management grant. No real provider is connected.",
  "role.operator.primary": "Open recovery queue",
  "role.operator.task1.title": "Access recovery",
  "role.operator.task1.body": "Confirm revocation before releasing a held card.",
  "role.operator.task2.title": "Provider readiness",
  "role.operator.task2.body": "Inspect supported-operation and read-back requirements.",
  "role.operator.task3.title": "Background work",
  "role.operator.task3.body": "Simulate failure or retry; transport health is not success.",
  "role.visitor.title": "Visitor",
  "role.visitor.heading": "A confident start to your visit.",
  "role.visitor.intro": "Review your invitation and complete pre-registration without entering the staff workspace.",
  "role.visitor.boundary": "Invitation-scoped synthetic preview; no public directory, real login, QR credential or identity-provider connection.",
  "role.visitor.primary": "Open invitation",
  "role.kiosk.title": "Shared-device kiosk",
  "role.kiosk.heading": "Welcome to Dubai HQ.",
  "role.kiosk.intro": "Find a synthetic invitation or request assistance. No staff workspace is exposed.",
  "role.kiosk.boundary": "Reference lookup only. Real token protection, scanning, walk-in policy, Arabic and hardened device management remain pending.",
  "role.kiosk.primary": "Open kiosk",
} as const;
